import { makeStyles } from "@material-ui/core/styles";
import { AEROS } from "../../styles/aerosTokens";

// Estilos da entrada de /tickets — mockup "Tela Aeros Dark - Atendimentos Nova
// Entrada", artboards "Entrada 1a Painel do dia" e "Entrada 1a Ticket
// selecionado". As medidas seguem o mockup: painel com padding 26/28,
// cartões radius 13-14, KPIs em grid de 4 colunas e o corpo em duas colunas
// 1.25fr / 1fr.

export const useEntryStyles = makeStyles((theme) => {
  const a = theme.palette.aeros;
  const isLight = theme.palette.type === "light";
  const linha = isLight ? a.border : "rgba(255,255,255,0.06)";
  const linhaFraca = isLight ? a.border : "rgba(255,255,255,0.05)";
  const cartao = isLight ? a.border : "rgba(255,255,255,0.07)";

  return {
    // ---------- casca ----------
    root: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      background: a.sidebar,
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
      overflowX: "hidden",
    },

    // ---------- cabeçalho do painel do dia ----------
    header: {
      flex: "none",
      padding: "26px 28px 0",
      display: "flex",
      alignItems: "flex-start",
      gap: 16,
      [theme.breakpoints.down("sm")]: {
        padding: "18px 16px 0",
        flexWrap: "wrap",
        gap: 12,
      },
    },
    headerAvatar: {
      width: 52,
      height: 52,
      borderRadius: 14,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 17,
      fontWeight: 800,
      flex: "none",
    },
    headerTexts: { flex: 1, minWidth: 0 },
    headerTitle: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 24,
      fontWeight: 700,
      letterSpacing: "-0.03em",
      color: theme.palette.text.primary,
      margin: 0,
    },
    headerSubtitle: {
      fontSize: 13,
      color: theme.palette.text.secondary,
      marginTop: 3,
    },
    headerActions: {
      display: "flex",
      gap: 8,
      alignItems: "center",
      flex: "none",
    },
    ghostButton: {
      border: `1px solid ${isLight ? a.borderStrong : "rgba(255,255,255,0.14)"}`,
      borderRadius: 10,
      padding: "9px 14px",
      fontSize: 12.5,
      fontWeight: 600,
      color: theme.palette.text.primary,
      textTransform: "none",
      gap: 6,
      whiteSpace: "nowrap",
    },
    gradientButton: {
      background: theme.palette.aerosGradient,
      color: "#07080D",
      borderRadius: 10,
      padding: "9px 16px",
      fontSize: 13,
      fontWeight: 700,
      textTransform: "none",
      gap: 6,
      whiteSpace: "nowrap",
      "&:hover": { filter: "brightness(1.08)" },
      "&.Mui-disabled": { opacity: 0.5, color: "#07080D" },
    },

    // ---------- corpo ----------
    body: {
      padding: "22px 28px 28px",
      display: "flex",
      flexDirection: "column",
      gap: 16,
      [theme.breakpoints.down("sm")]: { padding: "16px 16px 24px" },
    },

    // Três colunas, não as quatro do mockup: o quarto KPI ("Sua média de
    // resposta") depende de cálculo que o backend ainda não faz, e uma coluna
    // vazia leria como card quebrado. Volta a 4 quando o dado existir.
    kpiGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: 12,
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
      },
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
      },
    },
    kpiCard: {
      background: a.surface,
      border: `1px solid ${cartao}`,
      borderRadius: 13,
      padding: "15px 17px",
      minWidth: 0,
    },
    kpiCardAlert: { borderColor: "rgba(251,191,36,0.28)" },
    kpiTop: { display: "flex", alignItems: "center", gap: 8 },
    kpiIcon: { fontSize: 17 },
    kpiLabel: {
      fontSize: 11,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      letterSpacing: "0.06em",
    },
    kpiValue: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 26,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      marginTop: 6,
      fontVariantNumeric: "tabular-nums",
      color: theme.palette.text.primary,
    },
    kpiHint: {
      fontSize: 11.5,
      color: a.textTertiary,
      marginTop: 1,
      minHeight: 17,
    },

    columns: {
      display: "grid",
      gridTemplateColumns: "minmax(0, 1.25fr) minmax(0, 1fr)",
      gap: 16,
      alignItems: "start",
      [theme.breakpoints.down("md")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
      },
    },
    sideColumn: { display: "flex", flexDirection: "column", gap: 16, minWidth: 0 },

    card: {
      background: a.surface,
      border: `1px solid ${cartao}`,
      borderRadius: 14,
      overflow: "hidden",
      minWidth: 0,
    },
    cardPadded: { padding: "16px 18px" },
    cardHeader: {
      display: "flex",
      alignItems: "center",
      gap: 10,
      padding: "15px 18px 12px",
      borderBottom: `1px solid ${linha}`,
    },
    cardTitle: {
      fontSize: 13.5,
      fontWeight: 700,
      color: theme.palette.text.primary,
    },
    cardAction: {
      marginLeft: "auto",
      fontSize: 11.5,
      fontWeight: 600,
      color: AEROS.cyan,
      textTransform: "none",
      padding: 0,
      minWidth: 0,
      "&:hover": { background: "transparent", textDecoration: "underline" },
    },
    cardCount: {
      marginLeft: "auto",
      fontSize: 11,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      background: isLight ? a.surface2 : "rgba(255,255,255,0.06)",
      borderRadius: 6,
      padding: "2px 8px",
    },
    emptyLine: {
      fontSize: 12.5,
      color: theme.palette.text.secondary,
      padding: "14px 18px",
    },

    // ---------- filas ----------
    queueRow: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      padding: "13px 18px",
      borderBottom: `1px solid ${linhaFraca}`,
      "&:last-child": { borderBottom: "none" },
      [theme.breakpoints.down("xs")]: { flexWrap: "wrap" },
    },
    queueTile: {
      width: 34,
      height: 34,
      borderRadius: 10,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flex: "none",
    },
    queueTexts: { flex: 1, minWidth: 0 },
    queueName: {
      fontSize: 13,
      fontWeight: 600,
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    queueDetail: { fontSize: 11.5, color: theme.palette.text.secondary },
    queueCount: { textAlign: "right", flex: "none" },
    queueCountValue: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 19,
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums",
      lineHeight: 1.2,
    },
    queueCountLabel: { fontSize: 10.5, color: a.textTertiary },
    queueButton: {
      border: `1px solid ${isLight ? a.borderStrong : "rgba(255,255,255,0.16)"}`,
      borderRadius: 9,
      padding: "6px 13px",
      fontSize: 12,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: "none",
      flex: "none",
    },
    queueButtonPrimary: {
      borderColor: "rgba(160,68,255,0.4)",
      color: theme.palette.primary.main,
    },

    // ---------- agenda ----------
    agendaRow: { display: "flex", gap: 11, alignItems: "center" },
    agendaTime: {
      fontSize: 12.5,
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums",
      width: 42,
      flex: "none",
    },
    agendaBar: {
      width: 2,
      alignSelf: "stretch",
      borderRadius: 2,
      flex: "none",
      minHeight: 28,
    },
    agendaTexts: { minWidth: 0 },
    agendaContact: {
      fontSize: 12.5,
      fontWeight: 600,
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    agendaWhat: {
      fontSize: 11,
      color: theme.palette.text.secondary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },

    // ---------- precisa de atenção ----------
    attentionRow: {
      display: "flex",
      gap: 10,
      alignItems: "center",
      borderRadius: 10,
      padding: "9px 11px",
      textAlign: "left",
      textTransform: "none",
      width: "100%",
    },
    attentionText: {
      fontSize: 12,
      color: theme.palette.text.primary,
      lineHeight: 1.45,
      flex: 1,
    },

    stack: { display: "flex", flexDirection: "column", gap: 11 },
    stackTight: { display: "flex", flexDirection: "column", gap: 10 },

    // ---------- cartão de contexto ----------
    contextRoot: {
      flex: 1,
      minWidth: 0,
      height: "100%",
      background: a.sidebar,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    breadcrumb: {
      height: 52,
      flex: "none",
      display: "flex",
      alignItems: "center",
      gap: 9,
      padding: "0 24px",
      borderBottom: `1px solid ${linha}`,
      fontSize: 12.5,
      color: theme.palette.text.secondary,
      [theme.breakpoints.down("xs")]: { padding: "0 12px" },
    },
    breadcrumbBack: {
      padding: 5,
      borderRadius: 8,
      background: isLight ? a.surface2 : "rgba(255,255,255,0.05)",
      color: theme.palette.text.secondary,
    },
    breadcrumbLink: {
      textTransform: "none",
      fontSize: 12.5,
      fontWeight: 500,
      color: theme.palette.text.secondary,
      padding: 0,
      minWidth: 0,
      "&:hover": { background: "transparent", textDecoration: "underline" },
    },
    breadcrumbCurrent: {
      fontWeight: 700,
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    breadcrumbId: { color: a.textTertiary, fontWeight: 500 },

    contextBody: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 32,
      gap: 16,
      overflowY: "auto",
      [theme.breakpoints.down("xs")]: { padding: 16 },
    },
    contextCard: {
      width: 560,
      maxWidth: "100%",
      background: a.surface,
      border: "1px solid rgba(160,68,255,0.4)",
      borderRadius: 18,
      boxShadow: isLight
        ? "0 18px 40px rgba(15,20,40,0.10)"
        : "0 24px 60px rgba(0,0,0,0.45), 0 0 0 1px rgba(160,68,255,0.12)",
      overflow: "hidden",
    },
    contextHead: {
      padding: "22px 24px 18px",
      display: "flex",
      gap: 16,
      alignItems: "center",
      borderBottom: `1px solid ${linha}`,
      [theme.breakpoints.down("xs")]: { padding: "16px 16px 14px", gap: 12 },
    },
    contextAvatar: {
      width: 58,
      height: 58,
      fontSize: 19,
      fontWeight: 800,
      flex: "none",
    },
    contextName: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 19,
      fontWeight: 700,
      letterSpacing: "-0.02em",
      color: theme.palette.text.primary,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    contextMeta: {
      fontSize: 12.5,
      color: theme.palette.text.secondary,
      marginTop: 2,
    },
    contextWait: { textAlign: "right", flex: "none" },
    contextWaitValue: {
      fontFamily: AEROS.fontDisplay,
      fontSize: 22,
      fontWeight: 700,
      fontVariantNumeric: "tabular-nums",
      letterSpacing: "-0.02em",
      lineHeight: 1.2,
    },
    contextWaitLabel: { fontSize: 10.5, color: theme.palette.text.secondary },

    contextMain: {
      padding: "18px 24px",
      display: "flex",
      flexDirection: "column",
      gap: 14,
      [theme.breakpoints.down("xs")]: { padding: "14px 16px" },
    },
    chipRow: { display: "flex", gap: 8, flexWrap: "wrap" },
    chip: {
      fontSize: 11,
      fontWeight: 600,
      borderRadius: 6,
      padding: "3px 9px",
      display: "flex",
      alignItems: "center",
      gap: 5,
    },
    chipDot: { width: 7, height: 7, borderRadius: 2, flex: "none" },

    lastMessageBox: {
      background: isLight ? a.surface2 : a.sidebar,
      borderRadius: 12,
      padding: 14,
      display: "flex",
      flexDirection: "column",
      gap: 8,
    },
    lastMessageLabel: {
      fontSize: 10.5,
      fontWeight: 700,
      letterSpacing: "0.1em",
      textTransform: "uppercase",
      color: a.textTertiary,
    },
    lastMessageText: {
      fontSize: 13.5,
      lineHeight: 1.6,
      color: theme.palette.text.primary,
      overflowWrap: "anywhere",
    },
    lastMessageFoot: { fontSize: 11, color: a.textTertiary },

    contextGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
      gap: 10,
      [theme.breakpoints.down("xs")]: {
        gridTemplateColumns: "minmax(0, 1fr)",
      },
    },
    contextTile: {
      background: isLight ? a.surface2 : a.sidebar,
      borderRadius: 11,
      padding: "11px 12px",
      minWidth: 0,
    },
    contextTileLabel: {
      fontSize: 10.5,
      fontWeight: 600,
      color: theme.palette.text.secondary,
      textTransform: "uppercase",
      letterSpacing: "0.05em",
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    contextTileValue: {
      fontSize: 13.5,
      fontWeight: 700,
      marginTop: 4,
      color: theme.palette.text.primary,
      overflowWrap: "anywhere",
    },

    contextFoot: {
      padding: "16px 24px",
      borderTop: `1px solid ${linha}`,
      display: "flex",
      gap: 10,
      alignItems: "center",
      [theme.breakpoints.down("xs")]: { padding: "14px 16px", flexWrap: "wrap" },
    },
    contextGhost: {
      border: `1px solid ${isLight ? a.borderStrong : "rgba(255,255,255,0.16)"}`,
      borderRadius: 11,
      padding: "10px 16px",
      fontSize: 13,
      fontWeight: 600,
      color: theme.palette.text.primary,
      textTransform: "none",
      gap: 7,
      flex: "none",
      whiteSpace: "nowrap",
    },
    contextAccept: {
      // position relative: ButtonWithSpinner deixa o className de fora
      // sobrescrever o dele, e o CircularProgress e' absolute.
      position: "relative",
      flex: 1,
      minWidth: 200,
      background: theme.palette.aerosGradient,
      color: "#07080D",
      borderRadius: 11,
      padding: 11,
      fontSize: 14,
      fontWeight: 800,
      textTransform: "none",
      gap: 8,
      "&:hover": { filter: "brightness(1.08)" },
      "&.Mui-disabled": { opacity: 0.5, color: "#07080D" },
    },
    contextHint: {
      fontSize: 11.5,
      color: a.textTertiary,
      display: "flex",
      alignItems: "center",
      gap: 6,
      textAlign: "center",
    },
  };
});
